import { useTranslation } from 'next-i18next';
import React, { useMemo } from 'react';

import { getCardData } from '@/modules/packhouse/printingOrders/components/SupervisorsListing/SupervisorOrderRow/OrdersList/OrderCardContent/logic';
import Printing from '@/modules/packhouse/printingOrders/components/SupervisorsListing/SupervisorOrderRow/OrdersList/OrderCardContent/Printing';
import { IPrintingOrders } from '@/modules/packhouse/printingOrders/types';
import { Typography } from '@/shared/components/atoms';

interface IProps {
  order: IPrintingOrders.IOrderItem;
  orderDetails?: IPrintingOrders.IOrderDetailsItem;
  supervisor?: IPrintingOrders.IUser;
}

const OrderCardContent: React.FC<IProps> = ({
  orderDetails,
  order,
  supervisor,
}) => {
  const { t } = useTranslation('common');
  const cardData = useMemo(
    () =>
      getCardData({
        orderDetails,
      }),
    [orderDetails]
  );

  return (
    <div className='flex w-full items-center justify-between gap-2'>
      <div className=' flex items-center  gap-56  overflow-x-auto whitespace-nowrap py-16 overflow-y-hidden scrollbar-thin scrollbar-thumb-background-disable scrollbar-thumb-rounded-lg scrollbar-w-5 scrollbar-h-5'>
        {Object.entries(cardData).map(([key, value]) => (
          <div key={key} className='max-w-1/5 flex flex-col gap-1'>
            <div className='w-fit'>
              <Typography variant='body2' className='capitalize text-text-600'>
                {t(key)}
              </Typography>
              <Typography variant='subtitle2'>{value}</Typography>
            </div>
          </div>
        ))}
      </div>
      <div>
        <Printing
          order={order}
          orderDetails={orderDetails}
          supervisor={supervisor}
        />
      </div>
    </div>
  );
};

export default OrderCardContent;
